import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_14 = { class: "row mt-2" }
const _hoisted_15 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = { class: "row mt-2" }
const _hoisted_18 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_19 = { class: "col-sm-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.rewards")) + ", %:", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`traderRewardFee`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.traderRewardFeePercent) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.form.traderRewardFeePercent]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.start_at")) + ":", 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`startAt`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_DatePicker, {
                  class: _normalizeClass(parentProps.class),
                  modelValue: _ctx.form.startAt,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.startAt) = $event)),
                  mode: "dateTime",
                  "model-modifiers": {string: true},
                  is24hr: "",
                  masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                }, {
                  default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                    _createElementVNode("input", {
                      class: _normalizeClass(["form-control", parentProps.class]),
                      placeholder: _ctx.helper.trans('labels.start_at'),
                      value: inputValue,
                      onFocus: togglePopover,
                      onChange: inputEvents.change
                    }, null, 42, _hoisted_9)
                  ]),
                  _: 2
                }, 1032, ["class", "modelValue"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.expire_at")) + ":", 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`expiredAt`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_DatePicker, {
                  class: _normalizeClass(parentProps.class),
                  modelValue: _ctx.form.expiredAt,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.expiredAt) = $event)),
                  mode: "dateTime",
                  "model-modifiers": {string: true},
                  is24hr: "",
                  masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                }, {
                  default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                    _createElementVNode("input", {
                      class: _normalizeClass(["form-control", parentProps.class]),
                      placeholder: _ctx.helper.trans('labels.expire_at'),
                      value: inputValue,
                      onFocus: togglePopover,
                      onChange: inputEvents.change
                    }, null, 42, _hoisted_13)
                  ]),
                  _: 2
                }, 1032, ["class", "modelValue"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans("labels.traffic_group")) + ":", 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_TrafficGroupMultiselect, {
              multiple: false,
              modelValue: _ctx.form.trafficGroup,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.trafficGroup) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.helper.trans("labels.traders")) + ":", 1),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_TraderMultiselect, {
              multiple: true,
              modelValue: _ctx.form.traders,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.traders) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}